import { Fragment } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider as ReduxProvider } from 'react-redux';
import App from './App';
import { store } from 'store';
import reportWebVitals from './reportWebVitals';
import ErrorHandlerWrapper from 'ErrorHandlerWrapper';

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
	<Fragment>
		<ReduxProvider store={store}>
			<BrowserRouter basename="/">
				<ErrorHandlerWrapper>
					<App />
				</ErrorHandlerWrapper>
			</BrowserRouter>
		</ReduxProvider>
	</Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
